module.exports = __webpack_public_path__ + "img/bofang-title.7e39008c.png";